import { cn } from "../../../lib";

interface DescriptionItemProps {
  item: {
    label: string;
    content?: string;
    link?: string;
    className?: string;
  };
  layoutClass?: string;
  className?: string;
  children?: React.ReactNode;
}

const DescriptionItem = (props: DescriptionItemProps) => {
  const {
    item = { label: "", content: "", className: "" },
    children,
    layoutClass = "horizontal",
    className,
  } = props;

  return (
    <div
      className={cn(
        `flex ${
          layoutClass === "horizontal"
            ? "flex-col lg:flex-row items-start lg:items-center gap-0 lg:gap-2.5"
            : "flex-col items-start gap-0"
        }`,
        className,
      )}
    >
      <span className="text-md">{item.label}:</span>
      <span
        className={cn(
          `font-bold w-full wrap-anywhere ${layoutClass === "horizontal" ? " lg:truncate" : ""}`,
          item.className,
        )}
        title={item.content}
      >
        {item.link ? (
          <a
            href={item.link}
            target="_blank"
            className="text-lf-blue-light cursor-pointer wrap-anywhere"
          >
            {item.content}
          </a>
        ) : (
          item.content
        )}

        {children}
      </span>
    </div>
  );
};

DescriptionItem.displayName = "DescriptionItem";

export default DescriptionItem;
export type { DescriptionItemProps };
